import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { SiteContentProvider } from "@/context/SiteContent";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <SiteContentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </SiteContentProvider>
  );
}

export default App;
